import { IOrganization } from "@/api";
import { formatDate } from "@/utils";
import { Stack, Typography } from "@mui/material";
import { EditOrganizationButton } from "./buttons/EditOrganizationButton";
import { ViewOrganizationButton } from "./buttons/ViewOrganizationButton";

interface IProps {
    /**
     * the organization to display the information of
     */
    organization: IOrganization;
}

/**
 * a component that displays the information of an organization
 * Also displays actions to perform for the organization
 */
export const OrganizationInformation = ({ organization }: IProps) => {
    return (
        <Stack p={2} gap={2}>
            <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <Typography variant="h6">Information</Typography>

                <Stack direction={"row"} spacing={0.5}>
                    <EditOrganizationButton organization={organization} />
                    <ViewOrganizationButton organization={organization} />
                </Stack>
            </Stack>

            <Stack spacing={0.5}>
                <Typography
                    variant="body2"
                    color="textSecondary"
                    fontWeight={500}
                >
                    Date Created
                </Typography>
                <Typography variant="body2">
                    {formatDate(organization.created_at)}
                </Typography>
            </Stack>

            <Stack spacing={0.5}>
                <Typography
                    variant="body2"
                    color="textSecondary"
                    fontWeight={500}
                >
                    Industry
                </Typography>
                <Typography variant="body2">
                    {organization.industry?.name ?? "-"}
                </Typography>
            </Stack>
        </Stack>
    );
};
